import React from 'react';
import { AlertActivityHistoryRecord } from 'Generated/schema';
import useRouter from 'Hooks/useRouter';
import { Button, Box, Flex, Heading, Section, Alert } from 'pounceV2';
import BulletedLoadingV3 from 'Components/BulletedLoading/BulletedLoadingV3';
import ErrorBoundaryV3 from 'Components/ErrorBoundary/ErrorBoundaryV3';
import { extractErrorMessage } from 'Helpers/utils';
import { useAlertActivityHistory } from './graphql/alertActivityHistory.generated';
import CommentFormV3 from '../CommentForm/CommentFormV3';
import AlertHistoryEventV3 from './AlertHistoryEventV3';

export const ALERT_ACTIVITY_PAGE_SIZE = 15;

const AlertHistorySectionV3 = () => {
  const { match } = useRouter<{ id: string }>();
  const alertId = match.params.id;

  const { data, loading, error, refetch } = useAlertActivityHistory({
    variables: {
      id: alertId,
      activityHistoryPageInfo: {
        pageSize: ALERT_ACTIVITY_PAGE_SIZE,
      },
    },
  });

  const fetchAllActivityHistory = React.useCallback(() => {
    refetch({
      id: alertId,
      activityHistoryPageInfo: {
        pageSize: null,
      },
    });
  }, [refetch, alertId]);

  const activityHistory = data?.alert?.activityHistory;
  const hasNextPage = activityHistory?.pageInfo.hasNextPage;
  return (
    <Section>
      <Heading variant="h5" data-dd-privacy="allow">
        Activity
      </Heading>

      <CommentFormV3 />
      {error && (
        <Alert
          variant="warning"
          title="Couldn't fetch alert activity"
          description={extractErrorMessage(error)}
        />
      )}
      {activityHistory && (
        <React.Fragment>
          <Box as="ul">
            <ErrorBoundaryV3>
              {activityHistory.edges.map((historyEvent, idx) => {
                const isFinal = idx === activityHistory.edges.length - 1 && !hasNextPage;
                const alertActivityHistoryRecord = historyEvent.node as AlertActivityHistoryRecord;
                return (
                  <li key={alertActivityHistoryRecord.id}>
                    <AlertHistoryEventV3 event={alertActivityHistoryRecord} isFinal={isFinal} />
                  </li>
                );
              })}
            </ErrorBoundaryV3>
          </Box>
          {hasNextPage && (
            <Flex justify="center">
              <Button
                size="small"
                variant="secondary"
                onClick={fetchAllActivityHistory}
                disabled={loading}
              >
                Show all activities
              </Button>
            </Flex>
          )}
        </React.Fragment>
      )}
      {loading && (
        <Flex justify="center" mt={10}>
          <BulletedLoadingV3 />
        </Flex>
      )}
    </Section>
  );
};

export default AlertHistorySectionV3;
